// This file is generated automatically. Do not modify it.
export const IMAGES = [
    {
        alt: 'team working together in bright office with laptops',
        className:
            'block left-[7.73%] top-[104.68%] w-[36.27%] aspect-[136/180] md:block md:left-[6.67%] md:top-[56.39%] md:w-[15.28%] md:aspect-[220/280]',
        layer: 'back',
        src: '/work/hero-section/team-working-together-in-bright-office-with-laptops.jpeg',
    },
    {
        alt: 'three coworkers chatting around table in sunlit office',
        className:
            'block left-[13.33%] top-[64.04%] w-[89.33%] aspect-[335/230] md:block md:left-[32.01%] md:top-[68.70%] md:w-[36.04%] md:aspect-[519/361]',
        src: '/work/hero-section/three-coworkers-chatting-around-table-in-sunlit-office.jpeg',
    },
    {
        alt: 'two women collaborating and smiling in front of laptop',
        className:
            'block left-[58.67%] top-[110.84%] w-[42.67%] aspect-[160/210] md:block md:left-[78.06%] md:top-[48.89%] md:w-[15.28%] md:aspect-[220/280]',
        layer: 'back',
        src: '/work/hero-section/two-women-collaborating-and-smiling-in-front-of-laptop.jpeg',
    },
    {
        alt: 'three men collaborating and looking at computer monitor',
        className:
            'hidden md:block md:left-[12.57%] md:top-[136.76%] md:w-[19.44%] md:aspect-[280/320]',
        src: '/work/hero-section/three-men-collaborating-and-looking-at-computer-monitor.jpeg',
    },
    {
        alt: 'team meeting with whiteboard presentation and discussion',
        className:
            'block left-[25.60%] top-[209.36%] w-[53.33%] aspect-[200/240] md:block md:left-[37.85%] md:top-[168.33%] md:w-[15.97%] md:aspect-[230/300]',
        layer: 'back',
        src: '/work/hero-section/team-meeting-with-whiteboard-presentation-and-discussion.jpeg',
    },
    {
        alt: 'team brainstorming around large meeting table with laptops',
        className:
            'block left-[5.33%] top-[203.20%] w-[80.00%] aspect-[300/200] md:block md:left-[58.40%] md:top-[144.63%] md:w-[30.56%] md:aspect-[440/300]',
        src: '/work/hero-section/team-brainstorming-around-large-meeting-table-with-laptops.jpeg',
    },
];
